import { ErrorResponse, GetBreaksReportRequest } from "../../../api";
import { BreakReportsList } from "../../../api/models/BreakReportsList";
import { BreakReportsRow } from "../../../api/models/BreakReportsRow";
import { BreaksRequest } from "../../../api/models/BreaksRequest";
import {
    BreaksState,
    TableSortState,
    breaksSlice,
    initTableSortState,
} from "../../../features/ShiftMonitoring/store";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../../../services/common/send_log";
import { commonSlice, store } from "../../../store";
import { getDriverById } from "../../common/drivers";
import { api } from "../../common/make_api";
import { Logout } from "../../login/login";

export const convertBreakTimestampToHrMin = (
    timestamp?: string | undefined | null
) => {
    if (!timestamp) {
        return "";
    }

    return timestamp.split("T")[1].split(":").slice(0, 2).join(":");
};

export async function resetBreakReports(): Promise<any> {
    store.dispatch(breaksSlice.actions.update_breaks(null));
}

const resetBreakState = () => {
    const newBreaksSelection: BreaksState = {
        officeName: "",
        driverId: -1000,
        driverName: "",
        shiftDate: "",
        shiftMin: "",
        breaksMin: "",
        needGuidance: "",
        tableSortState: initTableSortState("breaks"),
    };

    store.dispatch(
        breaksSlice.actions.update_selection_state(newBreaksSelection)
    );
};

export const updateSortState = async (
    col: string,
    direction: string
): Promise<void> => {
    await store.dispatch(
        breaksSlice.actions.update_table_sort({
            lastSortedColumn: col,
            sortDirection: direction,
        } as TableSortState)
    );
};

export async function selectBreakReports(
    shiftDate: string,
    officeId: number,
    driverId: number
): Promise<any> {
    store.dispatch(commonSlice.actions.startLoading());
    try {
        const state = store.getState();
        const _date = parseInt(shiftDate.split("-").join(""), 10);
        resetBreakState();

        const sessionOfficeIds = state.common.officeIds;
        let officeids = sessionOfficeIds ? sessionOfficeIds : undefined;

        if (officeId) {
            officeids = [officeId];
        }

        const breaksRequest: BreaksRequest = {
            officeIds: officeids,
            officeId: officeId,
            driverId: driverId,
            shiftDate: _date,
        };

        const req_breaks: GetBreaksReportRequest = {
            breaksRequest: breaksRequest,
        };

        const res_breaks = (await api
            .getShiftReportsAPI()
            .getBreaksReport(req_breaks)) as BreakReportsList;

        sendLog(
            ResourceType.SHIFTS_MONITORING,
            StatusType.GET_RESOURCE,
            ActionType.SELECT_BREAKS_REPORTS,
            {
                action_type: ActionType.SELECT_BREAKS_REPORTS.toString(),
                selected_date: shiftDate,
                driver_id: driverId,
                office_id: officeId,
            }
        );

        console.debug("Got breaks report........", res_breaks);

        if (res_breaks.breaks && res_breaks.breaks[0]) {
            const rec: BreakReportsRow = res_breaks.breaks[0];
            const elmt = getDriverById(rec.driverId, rec.officeId);

            const newBreaksSelection: BreaksState = {
                officeName: rec.officeName ? rec.officeName : "dummy",
                driverId: rec.driverId ? rec.driverId : -1000,
                driverName: elmt ? elmt.driverName : "",
                shiftDate: rec.shiftDate ? rec.shiftDate.toString() : "111",
                shiftMin: rec.shiftLenMin ? rec.shiftLenMin.toString() : "111",
                breaksMin: rec.breakLenMin ? rec.breakLenMin.toString() : "111",
                needGuidance: rec.needGuidance ? rec.needGuidance : "",
                tableSortState: initTableSortState("breaks"),
            };

            store.dispatch(
                breaksSlice.actions.update_selection_state(newBreaksSelection)
            );
        }
        store.dispatch(commonSlice.actions.updateSelectedOffice(officeId));
        store.dispatch(breaksSlice.actions.update_breaks(res_breaks.breaks));
        store.dispatch(breaksSlice.actions.update_table_sort(null));

        return res_breaks;
    } catch (err) {
        console.log("Got this error from break_reports:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        const res = (await (err as Response).json()) as ErrorResponse;
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
